import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Grid,
  Snackbar
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import MailIcon from '@material-ui/icons/Mail';
import PrintIcon from '@material-ui/icons/Print';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import CiktiSmsGonder from 'src/components/PrintSmsSend';
import axios from 'src/utils/axios';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';
import ReceiptIcon from '@material-ui/icons/Receipt';
import DescriptionIcon from '@material-ui/icons/Description';

const useStyles = makeStyles((theme) => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative'
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700]
    },
    width: '100%'
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  content: {
    minHeight: 430,
  },
}));

function Print({
  className, ReceiptNo, readonly, tasks
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [ciktiSms, setCiktiSms] = useState(false);
  const [ciktiTip, setCiktiTip] = useState(0);
  const [ciktiTipTxt, setCiktiTipTxt] = useState('');
  const SessionUser = getUser();
  const [loading, setLoading] = useState(false);
  const [emailAddress, setEmailAddress] = useState('');
  const [emailAddressPopUp, setEmailAddressPopup] = useState(false);
  const [uyariCiktiSms, setUyariCiktiSms] = useState(false);
  const [uyariAciklamaCiktiSms, setUyariAciklamaCiktiSms] = useState('');
  const [uyariTipCiktiSms, setUyariTipCiktiSms] = useState();
  const [ResponseType, setResponseType] = useState('success');
  const [ResponseDsc, setResponseDsc] = useState('');
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [domain, setDomain] = useState('');
  let DurumFisCiktiKontrol = false;
  let DurumRevizyonKartiKontrol = false;
  let DurumEvdeYokKontrol = false;
  const YazdirData = tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo));
  const durumKodu = parseInt(YazdirData[0].LatestStatus) || 0;
  const handleCiktiSmsClose = () => {
    setCiktiSms(false);
  };
  const YazdirMerkezeGonderData = tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo))
  DurumFisCiktiKontrol = false;
  DurumRevizyonKartiKontrol = false;
  DurumEvdeYokKontrol = false;

  const getDomainByTenant = async (workOrderId) => {
    try {
      setLoading(true);
      const response = await axios
        .get(`/getDomain/${workOrderId}`);
      if (response.data?.length > 0) {
        return response.data;
      }
    }
    catch (error) { }
    finally {
      setLoading(false);
    }
  }


  useEffect(() => {
    const getDomainByTenantAsync = async () => {
      var domain = await getDomainByTenant(ReceiptNo);
      if (domain) {
        var finalDomain = `${domain}nps/SiriusServicePaper/html/`
        setDomain(finalDomain);
      }
    }

    getDomainByTenantAsync();
  }, [])



  // React.useEffect(() => {
  if (YazdirMerkezeGonderData.length === 0) {
    return null;
  }
  if ([4, 45, 18, 11, 23, 31].indexOf(parseInt(YazdirMerkezeGonderData[0].LatestStatus)) !== -1) {
    DurumFisCiktiKontrol = true;
  }

  if ([10, 12, 46, 38, 11].indexOf(parseInt(YazdirMerkezeGonderData[0].LatestStatus)) !== -1) {
    DurumRevizyonKartiKontrol = true;
  }
  if (YazdirMerkezeGonderData[0].LatestStatus === 51) {
    DurumEvdeYokKontrol = true;
  }
  if (DurumFisCiktiKontrol === false
    && DurumRevizyonKartiKontrol === false
    && DurumEvdeYokKontrol === false
    && [23, 15, 31, 32].indexOf(parseInt(YazdirMerkezeGonderData[0].LatestStatus)) === -1
  ) {
    DurumFisCiktiKontrol = true;
  }
  if ([21, 22, 33, 42].indexOf(parseInt(YazdirMerkezeGonderData[0].DurumKodu)) !== -1) {
    DurumFisCiktiKontrol = false;
    DurumRevizyonKartiKontrol = false;
    DurumEvdeYokKontrol = false;
  }

  const Onizleme = (event, ciktiTipi) => {
    let Link = process.env.NODE_ENV !== "development" ? domain && domain !== '' ? domain : process.env.REACT_APP_CIKTI_URL : process.env.REACT_APP_CIKTI_URL;
    Link = `${Link}ServicePaper.html?WorkId=${YazdirMerkezeGonderData[0].WorkOrderGuid}` + '&TenantId=' + SessionUser.TenantId + '&LanguageId=' + localStorage.getItem('i18nextLng');
    event.persist();
    window.open(Link);
    event.persist();
  };

  const ReceiptPreview = (event, ciktiTipi) => {
    let Link = process.env.REACT_APP_CIKTI_URL;
    Link = `${Link}Receipt.html?WorkId=${YazdirMerkezeGonderData[0].WorkOrderGuid}` + '&TenantId=' + SessionUser.TenantId + `&LanguageId=${YazdirMerkezeGonderData[0]?.PreferredLanguage !== "" ? YazdirMerkezeGonderData[0]?.PreferredLanguage : localStorage.getItem('i18nextLng')}`;
    event.persist();
    window.open(Link);
    event.persist();
  };

  const GatePassPreview = (page) => {
    const languageId = YazdirMerkezeGonderData[0]?.PreferredLanguage || localStorage.getItem('i18nextLng');
    const queryString = `WorkId=${YazdirMerkezeGonderData[0].WorkOrderGuid}&TenantId=${SessionUser.TenantId}&LanguageId=${languageId}`;
    const link = `https://survey.beko.com/nps/SiriusGatePass/html/${page}.html?${queryString}`;
    window.open(link);
  };

  const CashRegister = (event, ciktiTipi, type) => {
    let Link = process.env.REACT_APP_CIKTI_URL;
    Link = `${Link}CashRegister.aspx?WorkId=${YazdirMerkezeGonderData[0].ReceiptNo}` + '&TenantId=' + SessionUser.TenantId + '&LanguageId=' + localStorage.getItem('i18nextLng') + '&Type=' + type;
    event.persist();
    window.open(Link);
    event.persist();
  };

  const Quotation = (event, ciktiTipi) => {
    UpdateWorkOrderStatusForQuotation();

    let Link = process.env.REACT_APP_CIKTI_URL;
    Link = `${Link}QuotationReport.html?WorkOrderId=${YazdirMerkezeGonderData[0].ReceiptNo}` + '&TenantId=' + SessionUser.TenantId + '&LanguageId=' + localStorage.getItem('i18nextLng');
    event.persist();
    window.open(Link);
    event.persist();
  };

  const QuotationPreview = (event, ciktiTipi) => {
    let Link = process.env.REACT_APP_CIKTI_URL;
    Link = `${Link}QuotationReport.html?WorkOrderId=${YazdirMerkezeGonderData[0].ReceiptNo}` + '&TenantId=' + SessionUser.TenantId + '&LanguageId=' + localStorage.getItem('i18nextLng');
    event.persist();
    window.open(Link);
    event.persist();
  };

  const UpdateWorkOrderStatusForQuotation = () => {
    axios
      .post('/SetWorkOrderStatusForQuotation/' + ReceiptNo)
      .then(response => {
        if (response.data[0].ErrorCode == 0) {
          setResponseType('success');
          setResponseDsc(t('success_message'));
          setOpenSnackbar(true);
        } else {
          setResponseType('error');
          setResponseDsc(response.data[0].ErrorMessage);
          setOpenSnackbar(true);
        }
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };


  const confirmOkey = (msg) => {
    confirmAlert({
      message: msg,
      buttons: [
        {
          label: t('Tamam'),
          onClick: () => { }
        }
      ]
    });
  };

  const sendEmailYes = (ReceiptNo, CustomerFullName, Email) => {
    const data = {
      ReceiptNo,
      Type: 2,
      Email,
      EmployeeId: parseInt(SessionUser.TechnicianId)
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoading(true);
    axios.post('/InsertWorkOrderNotification', data, config)
      .then((response) => {
        setUyariAciklamaCiktiSms(t('lblBasarili'));
        setUyariTipCiktiSms('success');
        setUyariCiktiSms(true);
        setEmailAddressPopup(false);
        setLoading(false);
      }).catch((error) => {
        confirmOkey(error.message);
        setEmailAddressPopup(false);
        setLoading(false);
      });
  };
  const uyariKapatCiktiSms = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyariCiktiSms(false);
  };

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader title={t('yazdir_title')} />
      {uyariCiktiSms ? (
        <Alert
          onClose={uyariKapatCiktiSms}
          open={uyariCiktiSms}
          message={uyariAciklamaCiktiSms || ''}
          variant={uyariTipCiktiSms}
        />
      ) : (
        <div />
      )}
      <Divider />
      <Snackbar
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          message={ResponseDsc}
          variant={ResponseType}
        />
      </Snackbar>
      <CardContent className={classes.content}>
        {
          loading
            ? (
              <CircularProgress
                status="loading"
                style={{ marginLeft: '50%' }}
              />
            )
            : <div />
        }
        <div className={classes.wrapper}>
          <div className={classes.wrapper}>
            <Button
              variant="contained"
              color="primary"
              className={classes.submitButton}
              onClick={(e) => Onizleme(e, 1)}
              endIcon={<PrintIcon>Yazdır</PrintIcon>}
            >
              {t('Fis_ciktisi_onizleme')}
            </Button>
            {Number(SessionUser.TenantId) === 75 && (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                  onClick={() => GatePassPreview('GatepassCostumer')}
                  endIcon={<PrintIcon />}
                >
                  {t('lblCustomerGatePassPreview', { defaultValue: 'Customer Gate Pass Preview' })}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                  onClick={() => GatePassPreview('GatePassOffice')}
                  endIcon={<PrintIcon />}
                >
                  {t('lblOfficeGatePassPreview', { defaultValue: 'Office Gate Pass Preview' })}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                  onClick={() => GatePassPreview('PaymentReceipt')}
                  endIcon={<PrintIcon />}
                >
                  {t('lblPaymentReceiptPreview', { defaultValue: 'Payment Receipt Preview' })}
                </Button>
              </>
            )}
            <Button
              variant="contained"
              color="primary"
              className={classes.submitButton}
              onClick={(e) => CashRegister(e, 1, 'CASH')}
              endIcon={<ReceiptIcon>Yazdır</ReceiptIcon>}
            >
              {t('Cash Register')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.submitButton}
              onClick={(e) => CashRegister(e, 1, 'CARD')}
              endIcon={<ReceiptIcon>Yazdır</ReceiptIcon>}
            >
              {t('Pos_Payment')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.submitButton}
              onClick={() => {
                setCiktiTip(1);
                setCiktiTipTxt('Fiş Çıktısı');
                setCiktiSms(true);
              }}
              endIcon={<SendIcon>Yazdır</SendIcon>}
            >
              {t('Fis_ciktisi_Sms_Gonder')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.submitButton}
              onClick={() => {
                setEmailAddress(YazdirMerkezeGonderData[0].CustomerEmail);
                setEmailAddressPopup(true);
              }}
              disabled={[21, 22, 33, 42].includes(durumKodu)}
              endIcon={<MailIcon />}
            >
              {t('Fis_ciktisi_Email_Gonder')}
            </Button>
            {(SessionUser.TenantId === 37 || SessionUser.TenantId === 61 || SessionUser.TenantId === 82 || SessionUser.TenantId === 48 || SessionUser.TenantId === 51) ? (
              <Button
                variant="contained"
                color="primary"
                className={classes.submitButton}
                onClick={(e) => QuotationPreview(e, 1)}
                endIcon={<DescriptionIcon></DescriptionIcon>}
              >
                {t('lblQuotationPreview')}
              </Button>
            ) : (
              <Grid item xs={12} sm={3} lg={3} align="right">
              </Grid>
            )}
            {(SessionUser.TenantId === 37 || SessionUser.TenantId === 61 || SessionUser.TenantId === 82 || SessionUser.TenantId === 48 || SessionUser.TenantId === 51) ? (
              <Button
                variant="contained"
                color="primary"
                className={classes.submitButton}
                onClick={(e) => Quotation(e, 1)}
                endIcon={<DescriptionIcon></DescriptionIcon>}
              >
                {t('lblQuotationSend')}
              </Button>
            ) : (
              <Grid item xs={12} sm={3} lg={3} align="right">
              </Grid>
            )}
            {SessionUser.TenantId === 48 || SessionUser.TenantId === 51 ?
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                  onClick={(e) => ReceiptPreview(e, 1)}
                  endIcon={<PrintIcon></PrintIcon>}
                >
                  {t('lblReceiptPreview')}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                  onClick={() => {
                    setCiktiTip(1);
                    setCiktiTipTxt('Fiş Çıktısı');
                    setCiktiSms(true);
                  }}
                  endIcon={<SendIcon></SendIcon>}
                >
                  {t('lblReceiptSms')}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                  onClick={() => {
                    setEmailAddress(YazdirMerkezeGonderData[0].CustomerEmail);
                    setEmailAddressPopup(true);
                  }}
                  disabled={[21, 22, 33, 42].includes(durumKodu)}
                  endIcon={<MailIcon />}
                >
                  {t('lblReceiptEmail')}
                </Button>
              </div>
              : ''}
          </div>
        </div>
      </CardContent>
      <CardActions className={classes.actions} />
      <CiktiSmsGonder
        onClose={handleCiktiSmsClose}
        forceOpen={() => setCiktiSms(true)}
        ReceiptNo={ReceiptNo}
        open={ciktiSms}
        ciktiTip={ciktiTip}
        ciktiTipTxt={ciktiTipTxt}
      />
      <Dialog
        open={emailAddressPopUp}
        fullWidth
        maxWidth="sm"
        onClose={() => setEmailAddressPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblEmail')}</DialogTitle>
        <DialogContent>
          <TextField
            size="small"
            id="Email"
            autoComplete="no"
            value={emailAddress}
            onChange={(event) => setEmailAddress(event.target.value)}
            fullWidth
            label={t('lblEmail')}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setEmailAddressPopup(false)}
            color="secondary"
          >
            {t('lblClose')}
          </Button>
          <Button
            onClick={() => {
              sendEmailYes(YazdirMerkezeGonderData[0].ReceiptNo, YazdirMerkezeGonderData[0].ContactName, emailAddress);
            }}
            color="primary"
          >
            {t('lblSave')}
          </Button>
        </DialogActions>
      </Dialog>
    </Card>

  );
}

Print.propTypes = {
  className: PropTypes.string
};

export default connect((state) => ({ tasks: state.tasks1 }))(Print);
